module.exports = __webpack_public_path__ + "static/img/leftUpTwo.b12df1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/leftUpTwo.png
// module id = GqWv
// module chunks = 0